import Nav from "@/components/Nav";
import Team from "@/components/Team";
import Footer from "@/components/Footer";

export default function TeamPage() {
  return (
    <>
      <Nav />
      <main>
        <Team />
      </main>
      <Footer />
    </>
  );
}
